import { normalizeError } from '../../../utils'
import { UsersApi } from '../../../services'
import { MatchedPFInitialState } from '../matchedPFs.slice'
import { IMatchedPF, RequestConfig } from '../../../types'
import { ActionReducerMapBuilder, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import {IPagedResponse} from "../../../types/Requests";

export const fetchCurrentUserMatchedPFsAsync = createAsyncThunk(
  'users/current/matchedPFs',
  async (
    { options }: { options?: RequestConfig },
    { rejectWithValue },
  ) => {
    try {
      const res = await UsersApi.fetchCurrentUserMatchedPFs(options)

      return (res as AxiosResponse<any, any>).data
    } catch (error: any) {
      const normalized = normalizeError(error, 'fetching current user matched pfs')
      return rejectWithValue(normalized)
    }
  },
)

export const fetchCurrentUserMatchedPFsAsyncBuilder = (
  builder: ActionReducerMapBuilder<MatchedPFInitialState>,
) => {
  builder.addCase(fetchCurrentUserMatchedPFsAsync.pending, (state) => {
    state.loading = true
    state.success = false
    state.error = ''
  })
  builder.addCase(
      fetchCurrentUserMatchedPFsAsync.fulfilled,
    (state, action: PayloadAction<IPagedResponse<IMatchedPF[]>>) => {
      const { items, ...rest } = action.payload

      state.data = items
      state.paging.rows = rest.rows
      state.paging.totalRows = rest.totalRows

      state.success = true
      state.loading = false
    },
  )
  builder.addCase(fetchCurrentUserMatchedPFsAsync.rejected, (state, action: PayloadAction<any>) => {
    state.success = false
    state.error = action.payload
    state.loading = false
  })
}
